import type { PolicyTypeQuoteFormInput } from 'app/home/create-quote/forms/policy-type/policy-type.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function policyTypeQuoteFormSelector(store: QuoteDraftSelectorState): PolicyTypeQuoteFormInput {
  const policyType = store.policyType();
  return { policyType };
}

export function policyTypeQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['policy-type']();
}
